// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export default interface IDocClassType {
  is_bind_type: boolean;
  is_errorable: boolean;
  name: string;
}
